import type { NextRequest } from "@/modules/fetch/types"
import type { I18nLocale } from "@/modules/i18n/types"
import type { Profile } from "@/modules/profile/api/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { PROFILE_ENDPOINT } from "@/modules/profile/api/constants"

type GetProfileParams = {
  hostname: string
  locale: I18nLocale
  req?: NextRequest
}

export const getProfile = async ({ hostname, locale, req }: GetProfileParams): Promise<Profile> => {
  return fetcher(PROFILE_ENDPOINT, {
    hostname,
    nextRequest: req,
    requestInit: {
      headers: {
        Accept: "application/json",
        "Accept-Language": locale,
      },
    },
    serviceDomain: "MONOLITH_API",
    storageKey: `profile::${hostname}::${locale}`,
  })
    .then(getResultFromResponse<Profile>({ transformResult: toCamelCaseKeys<Profile> }))
    .catch(handleFetchError(PROFILE_ENDPOINT))
}
